<template>

  <div class="flex-row gap-sm align-items-center flex-stretch">
    <dd-select
      :dropdownMenuStyle="{display: 'none'}"
      mode="tags"
      :token-separators="[',']"
      class="flex-stretch border-radius-xs bg-color-white font-size-sm"
      v-model="model"
      :name="name"
    ></dd-select>
    <dd-icon-button
      icon="mdi mdi-magnify"
      size="xl"
      @click="showSelectRecipientModal = true"
    />
    <SelectRecipientModal 
      :customerId="customerId" 
      :visible="showSelectRecipientModal" 
      @cancel="showSelectRecipientModal = false"
      @input="handleSubmitEmails"
    />
  </div>
</template>

<script>
import SelectRecipientModal from './SelectRecipientModal.vue';

export default {
  name: "RecipientInputComponent.vue",
  components:{
    SelectRecipientModal
  },
  props:{
    customerId: {
      type: [String, Number]
    },
    value: {
      type: Array
    },
    name: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      showSelectRecipientModal: false,
    }
  },
  methods: {
    handleSubmitEmails(emails){
      this.$emit('input', [...this.value, ...emails]);
    }
  },
  computed: {
    model: {
      get()  {
        return  this.value;
      },
      set(event)  {
        this.$emit('input', event);
      },
    }
  },  
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>